<template>
    <div>
        <BlockUI :blocked="isLoading">
            <ScrollPanel style="width: 98%; height: 90vh">
                <div class="p-grid">
                    <Card class="p-col-3 p-m-3">
                        <template #title>
                            <h3 style="text-align: center">
                                סטטוס כיתה : &nbsp; {{ statusGrade && getStatusFullName(statusGrade.reportGradeStatus)
                                }}
                            </h3>
                        </template>
                        <template #content>
                            <div v-if="statusGrade" class="p-d-flex p-jc-center ">
                                <Button
                                        v-if="user.role === 'ADMIN' && statusGrade.reportGradeStatus === 'WAIT_TO_ADMIN_AGREE'"
                                        label="אישור מנהל"
                                        v-tooltip.top="'אישור מנהל'"
                                        icon="pi pi-check"
                                        class="p-m-1 p-button-success"
                                        @click="updateStatusReportGrade('ADMIN_AGREE')"
                                />
                                <Button
                                        v-if="user.role === 'ADMIN' && (statusGrade.reportGradeStatus === 'WAIT_TO_ADMIN_AGREE' || statusGrade.reportGradeStatus === 'ADMIN_AGREE')"
                                        label="שלח לתיקון"
                                        v-tooltip.top="'שלח לתיקון'"
                                        icon="pi pi-ban"
                                        class="p-m-1 p-button-danger"
                                        @click="updateStatusReportGrade('RETURN')"
                                />
                                <Button
                                        v-if="statusGrade.reportGradeStatus === 'EDIT' || statusGrade.reportGradeStatus === 'RETURN'"
                                        label="הגש לאישור מנהל"
                                        v-tooltip.top="'הגש לאישור מנהל'"
                                        icon="pi pi-send"
                                        class="p-m-1 p-button-info"
                                        @click="updateStatusReportGrade('WAIT_TO_ADMIN_AGREE')"
                                />
                            </div>
                        </template>

                    </Card>
                    <Card class="p-col-3 p-m-3">
                        <template #title>
                            <h3 style="text-align: center"> עדכון נוכחות אחרון:   &#13;
                                {{ statusGrade.lastPresenceUpdate && getFullData(statusGrade.lastPresenceUpdate) || '-'
                                }}
                            </h3>
                        </template>
                        <template #content>
                            <div v-if="statusGrade" class="p-d-flex p-jc-center ">

                                <Button

                                        label="מלא נוכחות"
                                        :disabled="loadingPresences"
                                        v-tooltip.top="'מלא נוכחות'"
                                        :icon="loadingPresences ? 'pi pi-spin pi-spinner' : 'pi pi-calendar-plus'"
                                        class="p-m-1 p-button-info"
                                        @click="updatePresences()"
                                />
                            </div>
                        </template>

                    </Card>

                        <Card  v-if="statusGrade && statusGrade.reportGradeStatus === 'ADMIN_AGREE' || user.role === 'ADMIN' " class="p-col p-m-3 p-d-flex">
                            <template #title>
                                <h3 style="text-align: center">
                                    הדפסה
                                </h3>
                                <h6>
                                    תבנית הדפסה נלקחת ממזהה הגוגל דרייב שהוגדר לכיתה,
                                </h6>
                                <h6>
                                    בהדספת תלמיד ניתן להדפיס תבנית ספציפית - בהגדרת מזהה שונה במסך ניהול התלמידים.
                                </h6>
                            </template>
                            <template #content>
                                <div class="p-d-flex p-jc-center ">
                                    <input-text
                                            class="p-m-1" placeholder="תאריך להדפסה" v-model="dateHebrew">

                                    </input-text>
                                    <input-text
                                            class="p-m-1" placeholder="שם מורה להדפסה"
                                            v-model="teacherName">
                                    </input-text>

                                </div>
                            </template>
                            <template #footer>
                                <div class="p-d-flex p-jc-center ">
<!--                                    <input-text-->
<!--                                            class="p-m-1" placeholder="תבנית תעודה" v-model="reportStampName">-->
<!--                                    </input-text>-->

                                    <Button
                                            :disabled="statusGrade.lastPresenceUpdate  && !statusGrade.lastPresenceUpdate || loadingOldReports"
                                            icon="pi pi-print"
                                            label="הדפס כיתה"
                                            v-tooltip.top="'הדפס כיתה'"
                                            class="p-m-1 p-button-warning"
                                            @click="printReports(false)"
                                    />
                                    <Button
                                            :disabled="statusGrade.lastPresenceUpdate  && !statusGrade.lastPresenceUpdate || loadingOldReports"
                                            v-if="user.role === 'ADMIN'"
                                            icon="pi pi-print"
                                            label="קובץ מאוחד"
                                            v-tooltip.top="'הדפס כיתה בקובץ מאוחד'"
                                            class="p-m-1 p-button-warning"
                                            @click="printReports(true)"
                                    />
                                </div>
<!--                                :disabled="statusGrade.lastPresenceUpdate  && !statusGrade.lastPresenceUpdate"-->

                                <div class="p-d-flex p-jc-center ">
                                    <div
                                            class=" p-col 6 "
                                    >
                                        <Dropdown
                                                style="width: 100% ; text-align: center"
                                                filterPlaceholder=" חפש תלמיד"
                                                emptyFilterMessage=" לא נמצא תלמיד תואם"
                                                :filter="true"
                                                class=""
                                                optionLabel="lastname"
                                                v-model="selectedPupilToPrint"
                                                :options="pupilsFilter"
                                                placeholder="בחר תלמיד"
                                                data-key="id"
                                        >
                                            <template #value="slotProps">
                                                <div v-if="slotProps.value">
                                                    <span>{{ slotProps.value.lastname }} {{ slotProps.value.firstname }}</span>
                                                </div>
                                                <span v-else>
                      {{ slotProps.placeholder }}
                    </span>
                                            </template>
                                            <template #option="slotProps">
                                                <span>{{ slotProps.option.lastname }}  {{ slotProps.option.firstname }}</span>
                                            </template>
                                        </Dropdown>

                                    </div>
                                    <Button
                                            icon="pi pi-print"
                                            label="הדפס תלמיד"
                                            :disabled="selectedPupilToPrint === null || (statusGrade.lastPresenceUpdate  && !statusGrade.lastPresenceUpdate) || loadingOldReports"

                                            v-tooltip.top="'הדפס תלמיד'"
                                            class="p-m-1 p-button-warning"
                                            @click="printReportOnePupil"
                                    />
                                </div>
                                <Dropdown
                                        optionLabel="displayName"
                                        style="text-align: center; width:100%"
                                        v-model="oldReportToPrintName"
                                        :options="reportRanges"
                                        data-key="id"
                                        placeholder="בחר תעודת השוואה שתופיע בתעודה"
                                        @input="updateOldReport"
                                >

                                </Dropdown>
                            </template>
                        </Card>
                </div>
                <Card class="p-m-3">
                    <template #title>
                        <h3 style="text-align: center">
                            סטטוס תלמידים
                        </h3>
                    </template>
                    <template #content>

                        <DataTable
                                style="width: 98% !important;"
                                :rowClass="rowClass"
                                :value="pupilReports"
                                :paginator="false"
                                :resizableColumns="false"
                                columnResizeMode="fit"
                                class="
          p-datatable-customers
          p-datatable-sm
          p-datatable-gridlines
          p-datatable-striped
        "
                                :rows="40"
                                stateStorage="session"
                                stateKey="menage-list-table-options"
                                :loading="isLoading"
                                paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
                                :rowsPerPageOptions="[5, 10, 20, 50]"
                                currentPageReportTemplate="מציג {first} עד {last} מתוך {totalRecords}"
                        >
                            <template #header>
                                <div class="table-header">
                                    <div class="p-m-1 p-d-inline-flex">
                                        <!--              <span class="p-input-icon-left">-->
                                        <!--                <i class="pi pi-search" />-->
                                        <!--                <InputText-->
                                        <!--                        v-model="filters['global']"-->
                                        <!--                        placeholder="חיפוש ראשי"-->
                                        <!--                />-->
                                        <!--              </span>-->
                                    </div>

                                </div>
                                <h5>בעריכה או ממתין לאישור</h5>
                                <ProgressBar :value="waitToAminAgree"/>
                            </template>
                            <template #loading> טוען נתונים מהמערכת, אנא המתן...</template>

                            <!-- id -->

                            <Column
                                    bodyStyle="text-align: right; overflow: visible; color: #757575;"
                                    field="pupil"
                                    header="תלמיד"
                            >
                                <template #body="slotProps">
                                    {{ getPupilName(slotProps.data.pupil) }}
                                </template>
                            </Column>
                            <!--                    <Column-->
                            <!--                            bodyStyle="text-align: right; overflow: visible; color: #757575;"-->
                            <!--                            field="createdBy"-->
                            <!--                            header="יוצר"-->
                            <!--                    >-->
                            <!--                        <template #body="slotProps">-->
                            <!--                            {{ getUserFullName(slotProps.data.createdBy) }}-->
                            <!--                        </template>-->
                            <!--                    </Column>-->
                            <!--                    <Column-->
                            <!--                            bodyStyle="text-align: right; overflow: visible; color: #757575;"-->
                            <!--                            field="createdBy"-->
                            <!--                            header="נוצר ב-"-->
                            <!--                    >-->
                            <!--                        <template #body="slotProps">-->
                            <!--                            {{ getFullData(slotProps.data.ts)}}-->
                            <!--                        </template>-->
                            <!--                    </Column>-->
                            <Column
                                    bodyStyle="text-align: right; overflow: visible; color: #757575;"
                                    field="lastUpdate"
                                    header="עדכון אחרון"
                            >
                                <template #body="slotProps">
                                    {{ getFullData(slotProps.data.lastUpdate) }}
                                </template>
                            </Column>
                            <Column
                                    bodyStyle="text-align: right; overflow: visible; color: #757575;"
                                    field="statusReport"
                                    header="סטטוס"
                            >
                                <template #body="slotProps">
                                    {{ getStatusFullName(slotProps.data.statusReport) }}
                                </template>
                            </Column>

                            <!--                    <Column-->
                            <!--                            v-if="user.role === 'ADMIN'"-->
                            <!--                            bodyStyle="text-align: right; overflow: visible; color: #757575;"-->
                            <!--                            field="adminAgree"-->
                            <!--                            header="אישור מנהל"-->
                            <!--                    >-->
                            <!--                        <template #editor="slotProps">-->
                            <!--                            <Checkbox v-if="slotProps.data.statusReport === 'WAIT_TO_ADMIN_AGREE'" @change="adminAgree" v-model="slotProps.data.adminAgree" :binary="true" />-->
                            <!--                        </template>-->
                            <!--                        <template #body="slotProps">-->
                            <!--                            <Checkbox  :disabled="true" v-model="slotProps.data.adminAgree" :binary="true" />-->
                            <!--                        </template>-->
                            <!--                    </Column>-->
                            <!--                    <Column-->
                            <!--                            headerStyle="width: 8%; text-align: rtl"-->
                            <!--                            bodyStyle="text-align: right; overflow: visible; color: #757575;"-->
                            <!--                            header=""-->
                            <!--                    >-->
                            <!--                        <template #body="slotProps">-->
                            <!--                                              <Button-->
                            <!--                                                      :disabled="slotProps.data.statusReport === 'WAIT_TO_ADMIN_AGREE'" v-tooltip="'שלח לאישור מנהל'" icon="pi pi-check"-->
                            <!--                                                      @click.stop="reqAdminAgree(slotProps.data.id)"></Button>-->
                            <!--                        </template>-->
                            <!--                    </Column>-->
                        </DataTable>
                    </template>
                </Card>
                <ScrollTop target="parent" :threshold="30" class="custom-scrolltop"
                           icon="pi pi-arrow-up"/>
            </ScrollPanel>
        </BlockUI>
    </div>
</template>

<script>
import {mapState} from "vuex";
import {
    postData,
    getData,
    reqAdminAgree,
    getReportGradeStatus,
    updateReportGradeStatus,
    updateScore, updatePresenceFilled
} from './menageReport'

import Vue from "vue";
import {getUserFullName, getPupilFullName} from "@/utils/parseObj";
import {dateToHebrewAndTime} from "@/utils/hebrewDateFormat";
import Service from "@/service/Service";
import {printReports} from "@/utils/prints";

const TOPICS_TYPE = "topicsScores"
const BEHAVIORS_TYPE = "behaviorScores"
const PRESENCES_TYPE = "presenceScores"
const NOTE_TYPE = "reportNote"

export default {
    name: "pupils-list",
    props: {
        selectedGrade: {
            type: Object
        },
        selectedReportName: {
            type: Object
        },
    },
    mounted() {
        this.service = new Service();
        this.reportStampName = this.selectedGrade.reportTemplate

    },
    data() {
        return {
            pupilReports: [],
            statusGrade: null,
            selectedPupilToPrint: null,
            loadingPresences: false,
            isLoading: false,
            componentUpdate: 0,
            teacherName: "",
            dateHebrew: "",
            reportStampName: "",
            oldReportToPrintName: null,
            oldReportToPrint: null,
            loadingOldReports: false,

        }
    },
    created() {
        this.reportStampName = this.selectedGrade.reportTemplate
    },
    watch: {

        selectedReportName(a, b) {
            this.reportStampName = this.selectedGrade.reportTemplate

            this.getDataGorGrade()
        },
        selectedGrade(a, b) {
            this.reportStampName = b.reportTemplate

            if (b !== null) {
                this.getDataGorGrade()
            }
        }
    },
    methods: {
        async updateOldReport(){
             await this.getOldReports()
        },
        async updatePresences() {
            this.loadingPresences = true
            const presences = this.presenceStatus.filter(presence => presence.reportActive)
            for (const presence of presences) {
                const data = await this.service.getTotalPresenceByGradeAndSubject(this.selectedGrade.id, presence.id, this.selectedReportName.startDate, this.selectedReportName.endDate)

                for (const pupil of data) {
                    const obj = {
                        "name": this.selectedReportName.id,
                        "pupil": pupil.id,
                        "typeOfScore": 'presenceScores',
                        "scoresToUpdate": {
                            [presence.id]: {
                                "score": pupil.count,
                                "user": this.user.id,
                                "ts": new Date().getTime()
                            }
                        },
                    }

                    try {
                        await updateScore(obj)

                    } catch (e) {
                    }

                }
                // this.presencesGradeStatistics = {}
                // data.forEach(item => {
                //     this.presencesGradeStatistics[item.id] = item.count
                // })
            }
                const {data} = await updatePresenceFilled(this.selectedReportName.id, this.selectedGrade.id)
            this.statusGrade = data
            this.loadingPresences = false

        },
        printReportOnePupil(){
            const reportPupil = this.getPupilReport(this.selectedPupilToPrint.id)
            const oldReportPupil = this.getOldPupilReport(this.selectedPupilToPrint.id)
            if (reportPupil.length > 0){
                try {
                    printReports(
                        reportPupil,
                        this.teacherName,
                        this.selectedGrade.id,
                        this.dateHebrew,
                        false,
                        this.selectedReportName.displayName,
                        this.selectedPupilToPrint.reportTemplate || this.selectedGrade.reportTemplate,
                        oldReportPupil,
                        this.showErrorNotification

                    )
                } catch (e) {

                }

            } else {
                this.openNotification(
                    "danger",
                    `אופס`,
                    `לא קיימת תעודה למשתמש זה`
                );
            }
        },
        getPupilReport(pupilId){
           return this.pupilReports.filter(report => (report.pupil === pupilId && report.id))
        },  getOldPupilReport(pupilId){
           return this.oldReportToPrint?.filter(report => (report.pupil === pupilId && report.id))
        },
        async printReports(oneFile) {
            // let oldReportToPrint
            // if (this.oldReportToPrint !== null){
            //     oldReportToPrint = await this.getReports(this.oldReportToPrint )
            // }
            try {
            printReports(
                this.pupilReports,
                this.teacherName,
                this.selectedGrade.id,
                this.dateHebrew,
                oneFile,
                this.selectedReportName.displayName,
                this.selectedGrade.reportTemplate,
                this.oldReportToPrint,
                this.showErrorNotification

            )
        } catch (e) {

        }

        },
        showErrorNotification(){
            this.openNotification(
                "danger",
                `קרתה שגיאה`,
                `אולי נבחרה תבנית לא קיימת`
            )
        },
        async updateStatusReportGrade(status) {
            // const a = await reqAdminAgree(this.pupilReports.filter(report => report.id !== undefined).map((report) => report.id));
            const reportName = this.selectedReportName.id
            const {data} = await updateReportGradeStatus(reportName, this.selectedGrade.id, status);
            this.statusGrade = data

        },
        async reqAdminAgree(eventId) {
            await reqAdminAgree([eventId]);
            await this.getDataGorGrade()
        },
        async adminAgree(eventId) {
            await adminAgree([eventId]);
            await this.getDataGorGrade()
        },
        rowClass(data) {
            return ''
            // return data.enabled === false ? "row-unenabled" : null;
        },

        getFullData(date) {
            return dateToHebrewAndTime(date)
        },
        getUserFullName(userId) {
            let userIdFinal = userId
            if (userId !== undefined && userId.id === undefined) {
                const start = userId.indexOf('id') + 3
                const end = userId.indexOf(',')
                userIdFinal = userId.slice(start, end)
            }
            return getUserFullName(userIdFinal)
        },

        getStatusFullName(status) {
            const statusNames = {
                EMPTY: "ריק",
                EDIT: "בעריכה",
                RETURN: "חזר לתיקונים",
                WAIT_TO_ADMIN_AGREE: "ממתין לאישור מנהל",
                ADMIN_AGREE: "מאושר"
            }
            return statusNames[status] || 'ריק'
        },
        getPupilName(pupilId) {
            return getPupilFullName(pupilId)
        },
        getDate(dateLong) {
            return dateToHebrewAndTime(dateLong)
        },

        async getDataGorGrade() {
            this.isLoading = true
            await Promise.all([
                this.getReports(),
                this.getReportGradeStatus(),
            ])
            this.isLoading = false
        },
        async getOldReports() {
            return new Promise(async (resolve, reject) => {
                try {
                    this.loadingOldReports = true
                    const reportName = this.oldReportToPrintName.id
                    const {data} = await getData(reportName, this.selectedGrade.id)
                    this.oldReportToPrint = []
                    setTimeout(()=>{},3000)
                    this.pupilsFilter.forEach(pupil => {
                        this.oldReportToPrint.push(data.find(report => report.pupil === pupil.id) || {pupil: pupil.id})
                    })
                    this.loadingOldReports = false

                    resolve()
                } catch (e) {
                    reject()
                }
            })
        },
        async getReports() {
            return new Promise(async (resolve, reject) => {
                try {
                    const reportName = this.selectedReportName.id
                    const {data} = await getData(reportName, this.selectedGrade.id)
                    this.pupilReports = []
                    this.pupilsFilter.forEach(pupil => {
                        this.pupilReports.push(data.find(report => report.pupil === pupil.id) || {pupil: pupil.id})
                        // this.pupilReports[pupil.id] =
                    })
                    resolve()
                } catch (e) {
                    reject()
                }
            })
        }, async getReportGradeStatus() {
            return new Promise(async (resolve, reject) => {
                try {
                    const reportName = this.selectedReportName.id
                    const {data} = await getReportGradeStatus(reportName, this.selectedGrade.id)
                    this.statusGrade = data
                    resolve()
                } catch (e) {
                    reject()
                }
            })
        },
        openNotification(color, title, text, position = "right-left", duration = 3000) {
            this.$vs.notification({color, position, title, text, duration, progress: 'auto'});
        },

    },
    computed: {
        waitToAminAgree() {
            const waiting = this.pupilReports.filter(report => report.statusReport === 'EDIT' || report.statusReport === 'WAIT_TO_ADMIN_AGREE').length
            const total = this.pupilReports.length
            const percents = waiting / total * 100
            return percents
        },
        ...mapState(["intro", "pupils", "user", "gradeOptions", "presenceStatus", "reportRanges"]),
        pupilsFilter() {
            return this.pupils?.filter((p) => p?.grade?.id ===
                this.selectedGrade?.id);
        },

    }
}
</script>

<style scoped>
>>> .p-card {
    justify-content: center;
    display: flex;
    align-items: center;
}
</style>